import { z } from 'zod';

/**
 * An ISO 8601 date-time whose seconds may be left out (`2026-07-30T09:00Z`), for a value Curium did
 * not generate itself: hand-set configuration, a provider's payload, or JSON stored by an earlier
 * release. From zod 4.5 `z.iso.datetime()` requires seconds whenever a value carries `Z` or an
 * offset (RFC 3339), and has no option to relax that; this accepts what it accepted before.
 *
 * Values Curium writes come from `toISOString()` and keep the strict schema. Not for an LLM tool's
 * input either: the union becomes an `anyOf`, and the strict schema's pattern already tells the
 * model to send seconds.
 */
export function isoDateTimeAllowingMinutes(options: { offset?: boolean } = {}) {
    return z.union([z.iso.datetime(options), z.iso.datetime({ ...options, precision: -1 })]);
}
